const REGEX = {
    ALPHA_ONLY_REGEX: /^[a-zA-Z -]+$/,
    NUMERIC_ONLY_REGEX: /^[0-9]+$/,
    ALPHA_NUMERIC_REGEX: /^[A-Za-z0-9]+$/,
    NAME_REGEX: /^[A-Za-z]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/,
    EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    MOBILE_CODE_REGEX: /^(\+?\d{1,4})$/,
    MOBILE_REGEX: /^[1-9]{1}[0-9]{9}$/,
    INT_MOBILE_REGEX: /^[0-9]{0,14}$/,
    PAN_REGEX: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
    GST_NUMBER_REGEX: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z,C]{1}[0-9A-Z]{1}$/,
    ADDRESS_REGEX: /^[a-zA-Z0-9-_@\/\.\, {2}]{1,100}$/,
    PINCODE_REGEX: /^[1-9][0-9]{5}$/,
    // PINCODE_REGEX: /^[a-zA-Z0-9\-\ ]{2,15}$/,
    CITY_REGEX: /^[a-zA-Z0-9-_@\/\. {2}]{1,50}$/,
    STATE_REGEX: /^[a-zA-Z0-9-_@\/\. {2}]{1,50}$/,
    PASSWORD_REGEX: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z!#$%&?@"])[a-zA-Z0-9!#$%&?@]{8,}$/,
    AADHAR_REGEX: /^([1-9]){12}$/
  };
  
  const errorMessages = {
    isRequired: fieldName => {
      return `${fieldName} is required`;
    },
    alpha: fieldName => {
      return `${fieldName} cannot have numbers or special characters`;
    },
    numeric: fieldName => {
      return `${fieldName} can only have numbers`;
    },
    alphanumeric: fieldName => {
      return `${fieldName} cannot have special characters`;
    },
    invalidField: fieldName => {
      return `Invalid ${fieldName}`;
    },
    invalidAadharField: fieldName => {
      return `Please enter a valid Aadhar number`;
    },
    fixedLength: (fieldName, len) => {
      return `${fieldName} must be of ${len} digits`;
    },
    minLength: (fieldName, len) => {
      return `${fieldName} must be of ${len} digits`;
    },
    aadharLength: (fieldName) => {
      return `${fieldName} must be of 12 digits`;
    },
    password: (fieldName, len, val) => {
      if (len < 6) {
        return `${fieldName} must be atleast 6 characters`;
      } else if (val.search(/\s/) >= 0) {
        return `${fieldName} cannot have space`;
      } else if (val.search(/[a-z]/) < 0) {
        return `${fieldName} must be have atleast alphabet`;
      } else if (val.search(/[0-9]/) < 0) {
        return `${fieldName} must be have atleast 1 number`;
      }
    },
    sameValue: (fieldName, otherFieldName) => {
      return `${fieldName} does not match with ${otherFieldName}`;
    },
    mustReadTnC: fieldName => {
      return `Please agree to the ${fieldName}`;
    },
  };
  
  const mustRead = ({value, fieldName}) => {
    if (value) return null;
    return errorMessages.mustReadTnC(fieldName);
  };
  
  const required = ({value, fieldName}) => {
    if (value) return null;
    return errorMessages.isRequired(fieldName);
  };
  
  const alpha = ({value, fieldName}) => {
    const regEx = REGEX.ALPHA_ONLY_REGEX;
    if (regEx.test(value) || value === '') return null;
    return errorMessages.alpha(fieldName);
  };
  
  const numeric = ({value, fieldName}) => {
    const regEx = REGEX.NUMERIC_ONLY_REGEX;
    if (regEx.test(value) || value === '') return null;
    return errorMessages.numeric(fieldName);
  };
  
  const alphanumeric = ({value, fieldName}) => {
    const regEx = REGEX.ALPHA_NUMERIC_REGEX;
    if (value === '' || regEx.test(value)) return null;
    return errorMessages.alphanumeric(fieldName);
  };
  
  const validEmail = ({value, fieldName}) => {
    const regEx = REGEX.EMAIL_REGEX;
    if (value === '' || regEx.test(value)) return null;
    return errorMessages.invalidField('email-id');
  };
  
  const validMobileCode = ({value, fieldName}) => {
    const regEx = REGEX.MOBILE_CODE_REGEX;
    if (regEx.test(value)) {
      return null;
    }
    return errorMessages.invalidField('country code');
  };
  
  const validMobileNumber = ({value, fieldName, countryCode}) => {
    let regEx = REGEX.MOBILE_REGEX;
    if (countryCode && countryCode !== '+91') {
      regEx = REGEX.INT_MOBILE_REGEX;
    }
    /*  Check if the length of the mobile number is 10 for India (+91) and for others the length lies between 4 and 15 */
    if (
      value === '' ||
      (regEx.test(value) &&
        ((countryCode === '+91' && value.length === 10) ||
          (countryCode !== '+91' && value.length > 3 && value.length < 16)))
    ) {
      return null;
    }
    return errorMessages.invalidField('mobile number');
  };

  const validAadharNumber = ({value, fieldName}) => {
    let regEx = REGEX.AADHAR_REGEX;
    /*  Check if the length of the aadhar number is 12 */
    if (value === '' || regEx.test(value) || value.length === 12) {return null};
    return errorMessages.invalidAadharField(fieldName);
  };
  
  const validPAN = ({value, fieldName}) => {
    const regEx = REGEX.PAN_REGEX;
    if (value === '' || regEx.test(value)) return null;
    return errorMessages.invalidField('PAN');
  };
  
  const validGSTNumber = ({value, fieldName}) => {
    const regEx = REGEX.GST_NUMBER_REGEX;
    if (value === '' || (regEx.test(value) && value.length === 15)) return null;
    return errorMessages.invalidField('GST number');
  };
  
  const validPincode = ({value, fieldName}) => {
    const regEx = REGEX.PINCODE_REGEX;
    if (value === '' || regEx.test(value)) return null;
    return errorMessages.invalidField('Pincode');
  };
  
  const validAddress = ({value, fieldName}) => {
    const regEx = REGEX.ADDRESS_REGEX;
    if (value === '' || regEx.test(value)) return null;
    return errorMessages.invalidField(fieldName);
  };
  
  const fixedLength = ({value, fieldName, length}) => {
    if (value.length === length) return null;
    return errorMessages.fixedLength(fieldName, length);
  };
  
  const minLength = ({value, fieldName, length}) => {
    if (value.length >= length) return null;
    return errorMessages.minLength(fieldName, length);
  };
  
  const password = ({value, fieldName}) => {
    return errorMessages.password(fieldName, value.length, value);
  };
  
  const sameValue = ({value, fieldName, valueToMatch, fieldToMatch}) => {
    if (value === valueToMatch) return null;
    return errorMessages.sameValue(fieldName, fieldToMatch);
  };

  export const validations = {
    required: required,
    mustRead: mustRead,
    alpha: alpha,
    numeric: numeric,
    alphanumeric: alphanumeric,
    validEmail: validEmail,
    validMobileCode: validMobileCode,
    validMobileNumber: validMobileNumber,
    validGSTNumber: validGSTNumber,
    validPAN: validPAN,
    validPincode: validPincode,
    validAddress: validAddress,
    fixedLength: fixedLength,
    minLength: minLength,
    password: password,
    sameFieldValue: sameValue,
    validAadharNumber: validAadharNumber
  };
  